/// <amd-module name="SuiteCommerce.GridOrder.PriceSchedule.Model"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.GridOrder.PriceSchedule.Model", ["require", "exports", "SuiteCommerce.GridOrder.Cell.Model"], function (require, exports, GridOrder_Cell_Model_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var PriceScheduleModel = /** @class */ (function (_super) {
        __extends(PriceScheduleModel, _super);
        function PriceScheduleModel() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        return PriceScheduleModel;
    }(GridOrder_Cell_Model_1.CellModel));
    exports.PriceScheduleModel = PriceScheduleModel;
});
